import React, { useState, useRef, useEffect } from "react";
import {
  BookOpen,
  Play,
  CheckCircle2,
  XCircle,
  Home,
  Trophy,
  ArrowRight,
  BookMarked,
  ChevronRight,
  Sparkles,
  ScrollText,
  Volume2,
  CheckSquare,
} from "lucide-react";

// --- 弟子規 100% 完整資料庫 (共1080字，180句) ---
const diZiGuiData = [
  // --- 總敘 (4) ---
  {
    id: 1,
    category: "總敘",
    first: "弟子規",
    second: "聖人訓",
    meaning: "《弟子規》這本書，是古聖先賢流傳下來的訓導。",
  },
  {
    id: 2,
    category: "總敘",
    first: "首孝弟",
    second: "次謹信",
    meaning: "首先要孝順父母、友愛兄弟姊妹，其次要生活謹慎、說話講信用。",
  },
  {
    id: 3,
    category: "總敘",
    first: "汎愛眾",
    second: "而親仁",
    meaning: "對於大眾要充滿愛心，並且親近有仁德的人。",
  },
  {
    id: 4,
    category: "總敘",
    first: "有餘力",
    second: "則學文",
    meaning: "做好了這些本分，如果還有多餘的心力，就應該努力學習文化知識。",
  },

  // --- 入則孝 (28) ---
  {
    id: 5,
    category: "入則孝",
    first: "父母呼",
    second: "應勿緩",
    meaning: "父母呼喚時，要立刻答應，不要遲緩。",
  },
  {
    id: 6,
    category: "入則孝",
    first: "父母命",
    second: "行勿懶",
    meaning: "父母交代的事情，要立刻動手去做，不可拖延偷懶。",
  },
  {
    id: 7,
    category: "入則孝",
    first: "父母教",
    second: "須敬聽",
    meaning: "父母教導我們做人處事的道理，必須恭敬地聆聽。",
  },
  {
    id: 8,
    category: "入則孝",
    first: "父母責",
    second: "須順承",
    meaning: "父母責備我們時，必須順從地接受，不可頂嘴。",
  },
  {
    id: 9,
    category: "入則孝",
    first: "冬則溫",
    second: "夏則凊",
    meaning: "冬天要讓父母溫暖，夏天要讓父母涼爽。",
  },
  {
    id: 10,
    category: "入則孝",
    first: "晨則省",
    second: "昏則定",
    meaning: "早晨要向父母請安，晚上要幫父母鋪床並道晚安。",
  },
  {
    id: 11,
    category: "入則孝",
    first: "出必告",
    second: "反必面",
    meaning: "出門前必須告訴父母，回家後必須當面稟報。",
  },
  {
    id: 12,
    category: "入則孝",
    first: "居有常",
    second: "業無變",
    meaning: "生活起居要規律正常，做事情要有恆心，不可見異思遷。",
  },
  {
    id: 13,
    category: "入則孝",
    first: "事雖小",
    second: "勿擅為",
    meaning: "事情雖然小，也不可以擅自做主而不稟告父母。",
  },
  {
    id: 14,
    category: "入則孝",
    first: "苟擅為",
    second: "子道虧",
    meaning: "如果擅自做主，就虧損了為人子女應盡的本分。",
  },
  {
    id: 15,
    category: "入則孝",
    first: "物雖小",
    second: "勿私藏",
    meaning: "物品雖然小，也不可以私自藏起來佔為己有。",
  },
  {
    id: 16,
    category: "入則孝",
    first: "苟私藏",
    second: "親心傷",
    meaning: "如果私自藏匿，父母知道了心裡會非常傷心。",
  },
  {
    id: 17,
    category: "入則孝",
    first: "親所好",
    second: "力為具",
    meaning: "父母喜歡的東西或事情，要盡力為他們準備好。",
  },
  {
    id: 18,
    category: "入則孝",
    first: "親所惡",
    second: "謹為去",
    meaning: "父母厭惡的東西或事情，要小心謹慎地幫他們去除。",
  },
  {
    id: 19,
    category: "入則孝",
    first: "身有傷",
    second: "貽親憂",
    meaning: "身體受了傷，會留給父母無盡的擔憂。",
  },
  {
    id: 20,
    category: "入則孝",
    first: "德有傷",
    second: "貽親羞",
    meaning: "品德有了污點，會讓父母感到蒙羞。",
  },
  {
    id: 21,
    category: "入則孝",
    first: "親愛我",
    second: "孝何難",
    meaning: "父母疼愛我，我孝順父母有什麼困難呢？",
  },
  {
    id: 22,
    category: "入則孝",
    first: "親憎我",
    second: "孝方賢",
    meaning: "父母不喜歡我，我還能依然孝順，這才是真正的賢德。",
  },
  {
    id: 23,
    category: "入則孝",
    first: "親有過",
    second: "諫使更",
    meaning: "父母如果有過錯，要勸導他們改正。",
  },
  {
    id: 24,
    category: "入則孝",
    first: "怡吾色",
    second: "柔吾聲",
    meaning: "勸導時面色要和悅，聲音要柔和。",
  },
  {
    id: 25,
    category: "入則孝",
    first: "諫不入",
    second: "悅復諫",
    meaning: "如果父母不聽勸，等他們心情好時再繼續勸導。",
  },
  {
    id: 26,
    category: "入則孝",
    first: "號泣隨",
    second: "撻無怨",
    meaning: "即使哭泣著跟隨勸導，甚至被責打，也絕無怨言。",
  },
  {
    id: 27,
    category: "入則孝",
    first: "親有疾",
    second: "藥先嘗",
    meaning: "父母生病時，煎好的湯藥自己要先嚐一嚐溫度。",
  },
  {
    id: 28,
    category: "入則孝",
    first: "晝夜侍",
    second: "不離床",
    meaning: "日夜侍奉在父母身邊，不隨便離開床前。",
  },
  {
    id: 29,
    category: "入則孝",
    first: "喪三年",
    second: "常悲咽",
    meaning: "父母去世要守喪三年，常常悲痛哭泣。",
  },
  {
    id: 30,
    category: "入則孝",
    first: "居處變",
    second: "酒肉絕",
    meaning: "生活起居要改變從簡，戒絕飲酒吃肉。",
  },
  {
    id: 31,
    category: "入則孝",
    first: "喪盡禮",
    second: "祭盡誠",
    meaning: "辦理喪事要符合禮節，祭拜時要完全發自內心的真誠。",
  },
  {
    id: 32,
    category: "入則孝",
    first: "事死者",
    second: "如事生",
    meaning: "對待過世的父母，要像他們活著的時候一樣恭敬。",
  },

  // --- 出則弟 (22) ---
  {
    id: 33,
    category: "出則弟",
    first: "兄道友",
    second: "弟道恭",
    meaning: "當哥哥的要友愛弟妹，做弟妹的要懂得恭敬兄長。",
  },
  {
    id: 34,
    category: "出則弟",
    first: "兄弟睦",
    second: "孝在中",
    meaning: "兄弟姊妹能和睦相處，這就是對父母盡孝了。",
  },
  {
    id: 35,
    category: "出則弟",
    first: "財物輕",
    second: "怨何生",
    meaning: "把金錢財物看得很輕，兄弟間哪裡會產生怨恨呢？",
  },
  {
    id: 36,
    category: "出則弟",
    first: "言語忍",
    second: "忿自泯",
    meaning: "講話時能互相忍讓，不說傷人的話，憤怒自然就會消失。",
  },
  {
    id: 37,
    category: "出則弟",
    first: "或飲食",
    second: "或坐走",
    meaning: "不論是吃東西、喝飲料，或者是坐著、走路。",
  },
  {
    id: 38,
    category: "出則弟",
    first: "長者先",
    second: "幼者後",
    meaning: "都要讓長輩優先，晚輩則跟在後面。",
  },
  {
    id: 39,
    category: "出則弟",
    first: "長呼人",
    second: "即代叫",
    meaning: "長輩在呼喚別人時，應該立刻代為傳喚。",
  },
  {
    id: 40,
    category: "出則弟",
    first: "人不在",
    second: "己即到",
    meaning: "如果那個人不在，自己就應該立刻到長輩面前看有什麼需要幫忙的。",
  },
  {
    id: 41,
    category: "出則弟",
    first: "稱尊長",
    second: "勿呼名",
    meaning: "稱呼長輩時，不可以直呼其名。",
  },
  {
    id: 42,
    category: "出則弟",
    first: "對尊長",
    second: "勿見能",
    meaning: "在長輩面前，不要賣弄自己的才能。",
  },
  {
    id: 43,
    category: "出則弟",
    first: "路遇長",
    second: "疾趨揖",
    meaning: "路上遇到長輩，要快步上前鞠躬問候。",
  },
  {
    id: 44,
    category: "出則弟",
    first: "長無言",
    second: "退恭立",
    meaning: "如果長輩沒有說話，就恭敬地退立一旁。",
  },
  {
    id: 45,
    category: "出則弟",
    first: "騎下馬",
    second: "乘下車",
    meaning: "遇到長輩時，騎馬的要下馬，乘車的要下車。",
  },
  {
    id: 46,
    category: "出則弟",
    first: "過猶待",
    second: "百步餘",
    meaning: "等長輩走過一百多步以後，自己才可以離開。",
  },
  {
    id: 47,
    category: "出則弟",
    first: "長者立",
    second: "幼勿坐",
    meaning: "長輩站立著的時候，晚輩不可以先坐下。",
  },
  {
    id: 48,
    category: "出則弟",
    first: "長者坐",
    second: "命乃坐",
    meaning: "長輩坐下後，吩咐我們坐，才可以坐下。",
  },
  {
    id: 49,
    category: "出則弟",
    first: "尊長前",
    second: "聲要低",
    meaning: "在長輩面前說話，聲音要放低。",
  },
  {
    id: 50,
    category: "出則弟",
    first: "低不聞",
    second: "卻非宜",
    meaning: "但如果低到長輩聽不清楚，那也是不合適的。",
  },
  {
    id: 51,
    category: "出則弟",
    first: "進必趨",
    second: "退必遲",
    meaning: "見長輩時要快步走近，離開時要腳步緩慢。",
  },
  {
    id: 52,
    category: "出則弟",
    first: "問起對",
    second: "視勿移",
    meaning: "長輩問話時要站起回答，目光注視長輩不可東張西望。",
  },
  {
    id: 53,
    category: "出則弟",
    first: "事諸父",
    second: "如事父",
    meaning: "對待別人的叔伯，要像對待自己的父親一樣恭敬。",
  },
  {
    id: 54,
    category: "出則弟",
    first: "事諸兄",
    second: "如事兄",
    meaning: "對待別人的兄長，要像對待自己的哥哥一樣友愛。",
  },

  // --- 謹 (34) ---
  {
    id: 55,
    category: "謹",
    first: "朝起早",
    second: "夜眠遲",
    meaning: "早上要起得早，晚上要晚點睡(多用功學習)。",
  },
  {
    id: 56,
    category: "謹",
    first: "老易至",
    second: "惜此時",
    meaning: "時光飛逝人易老，所以要珍惜現在的青春時光。",
  },
  {
    id: 57,
    category: "謹",
    first: "晨必盥",
    second: "兼漱口",
    meaning: "早晨起床必須洗臉，同時也要漱口刷牙。",
  },
  {
    id: 58,
    category: "謹",
    first: "便溺回",
    second: "輒淨手",
    meaning: "上完廁所回來後，一定要立刻把手洗乾淨。",
  },
  {
    id: 59,
    category: "謹",
    first: "冠必正",
    second: "紐必結",
    meaning: "帽子要戴得端正，衣服的鈕扣一定要扣好。",
  },
  {
    id: 60,
    category: "謹",
    first: "襪與履",
    second: "俱緊切",
    meaning: "穿的襪子和鞋子，都要穿得平整緊湊、合腳。",
  },
  {
    id: 61,
    category: "謹",
    first: "置冠服",
    second: "有定位",
    meaning: "放置帽子和衣服，都要有固定的位置。",
  },
  {
    id: 62,
    category: "謹",
    first: "勿亂頓",
    second: "致污穢",
    meaning: "不要隨便亂丟，導致衣物弄髒或起皺。",
  },
  {
    id: 63,
    category: "謹",
    first: "衣貴潔",
    second: "不貴華",
    meaning: "衣服貴在乾淨整潔，不在於華麗昂貴。",
  },
  {
    id: 64,
    category: "謹",
    first: "上循分",
    second: "下稱家",
    meaning: "穿著上要符合自己的身分，下要衡量家庭的經濟狀況。",
  },
  {
    id: 65,
    category: "謹",
    first: "對飲食",
    second: "勿揀擇",
    meaning: "對待日常飲食，不要挑食偏食。",
  },
  {
    id: 66,
    category: "謹",
    first: "食適可",
    second: "勿過則",
    meaning: "吃東西適量就好，不要吃得過多過飽。",
  },
  {
    id: 67,
    category: "謹",
    first: "年方少",
    second: "勿飲酒",
    meaning: "年紀還小的時候，絕對不可以喝酒。",
  },
  {
    id: 68,
    category: "謹",
    first: "飲酒醉",
    second: "最為醜",
    meaning: "喝醉酒之後胡言亂語、行為失態，是最醜陋的。",
  },
  {
    id: 69,
    category: "謹",
    first: "步從容",
    second: "立端正",
    meaning: "走路時步態要從容穩重，站立時姿勢要端正。",
  },
  {
    id: 70,
    category: "謹",
    first: "揖深圓",
    second: "拜恭敬",
    meaning: "作揖時身子要彎得深且圓潤，跪拜時要非常恭敬。",
  },
  {
    id: 71,
    category: "謹",
    first: "勿踐閾",
    second: "勿跛倚",
    meaning: "進門不要踩門檻，站立不要歪斜靠牆。",
  },
  {
    id: 72,
    category: "謹",
    first: "勿箕踞",
    second: "勿搖髀",
    meaning: "坐著不要雙腿張開像畚箕，也不要隨便抖動大腿。",
  },
  {
    id: 73,
    category: "謹",
    first: "緩揭簾",
    second: "勿有聲",
    meaning: "進門時揭開門簾動作要輕緩，不要發出聲響。",
  },
  {
    id: 74,
    category: "謹",
    first: "寬轉彎",
    second: "勿觸棱",
    meaning: "走路轉彎時要留有空間，不要撞到物品的稜角。",
  },
  {
    id: 75,
    category: "謹",
    first: "執虛器",
    second: "如執盈",
    meaning: "拿空著的器具，要像拿著裝滿東西的器具一樣小心。",
  },
  {
    id: 76,
    category: "謹",
    first: "入虛室",
    second: "如有人",
    meaning: "進入沒有人的空房間，行為也要像裡面有人一樣端莊。",
  },
  {
    id: 77,
    category: "謹",
    first: "事勿忙",
    second: "忙多錯",
    meaning: "做事不要慌慌張張，太慌忙就容易出錯。",
  },
  {
    id: 78,
    category: "謹",
    first: "勿畏難",
    second: "勿輕略",
    meaning: "不要害怕困難而退縮，也不要因為簡單而草率馬虎。",
  },
  {
    id: 79,
    category: "謹",
    first: "鬥鬧場",
    second: "絕勿近",
    meaning: "容易發生打鬥鬧事的場所，絕對不要靠近。",
  },
  {
    id: 80,
    category: "謹",
    first: "邪僻事",
    second: "絕勿問",
    meaning: "邪惡不正當的事情，絕對不要去好奇打聽。",
  },
  {
    id: 81,
    category: "謹",
    first: "將入門",
    second: "問孰存",
    meaning: "將要進入別人家門時，要先問有人在嗎。",
  },
  {
    id: 82,
    category: "謹",
    first: "將上堂",
    second: "聲必揚",
    meaning: "準備進入廳堂時，聲音一定要提高讓裡面的人知道。",
  },
  {
    id: 83,
    category: "謹",
    first: "人問誰",
    second: "對以名",
    meaning: "裡面的人問是誰，要清楚回答自己的名字。",
  },
  {
    id: 84,
    category: "謹",
    first: "吾與我",
    second: "不分明",
    meaning: "如果只回答「是我」，對方是聽不清楚到底是誰的。",
  },
  {
    id: 85,
    category: "謹",
    first: "用人物",
    second: "須明求",
    meaning: "借用別人的物品，必須明白地向人請求。",
  },
  {
    id: 86,
    category: "謹",
    first: "倘不問",
    second: "即為偷",
    meaning: "如果沒有經過允許就拿走，這就等同於偷竊。",
  },
  {
    id: 87,
    category: "謹",
    first: "借人物",
    second: "及時還",
    meaning: "借了別人的東西，用完後要及時歸還。",
  },
  {
    id: 88,
    category: "謹",
    first: "後有急",
    second: "借不難",
    meaning: "以後如果有急用，再向人借就不會困難了。",
  },

  // --- 信 (30) ---
  {
    id: 89,
    category: "信",
    first: "凡出言",
    second: "信為先",
    meaning: "只要開口說話，首先一定要講究誠實與信用。",
  },
  {
    id: 90,
    category: "信",
    first: "詐與妄",
    second: "奚可焉",
    meaning: "欺詐騙人或是胡言亂語，這些行為怎麼可以去做呢？",
  },
  {
    id: 91,
    category: "信",
    first: "話說多",
    second: "不如少",
    meaning: "話說得太多，不如說得少而精確。",
  },
  {
    id: 92,
    category: "信",
    first: "惟其是",
    second: "勿佞巧",
    meaning: "說話要實事求是，不要花言巧語。",
  },
  {
    id: 93,
    category: "信",
    first: "刻薄語",
    second: "穢污詞",
    meaning: "刻薄傷人的話語，以及骯髒下流的言詞。",
  },
  {
    id: 94,
    category: "信",
    first: "市井氣",
    second: "切戒之",
    meaning: "那些市井無賴的粗俗習氣，一定要徹底戒除。",
  },
  {
    id: 95,
    category: "信",
    first: "見未真",
    second: "勿輕言",
    meaning: "事情還沒有看清楚真相之前，不要隨便發表意見。",
  },
  {
    id: 96,
    category: "信",
    first: "知未的",
    second: "勿輕傳",
    meaning: "對於還不確定真實性的事情，不要隨便傳播。",
  },
  {
    id: 97,
    category: "信",
    first: "事非宜",
    second: "勿輕諾",
    meaning: "如果覺得事情不合理或做不到，不要輕易答應別人。",
  },
  {
    id: 98,
    category: "信",
    first: "苟輕諾",
    second: "進退錯",
    meaning: "如果輕易答應了，到時候做不到就會進退兩難。",
  },
  {
    id: 99,
    category: "信",
    first: "凡道字",
    second: "重且舒",
    meaning: "凡是講話吐字，都要清楚穩重且舒緩。",
  },
  {
    id: 100,
    category: "信",
    first: "勿急疾",
    second: "勿模糊",
    meaning: "講話不要太急躁，也不要含糊不清。",
  },
  {
    id: 101,
    category: "信",
    first: "彼說長",
    second: "此說短",
    meaning: "別人在那邊說長道短、議論是非。",
  },
  {
    id: 102,
    category: "信",
    first: "不關己",
    second: "莫閒管",
    meaning: "只要跟自己無關，就不要去多管閒事。",
  },
  {
    id: 103,
    category: "信",
    first: "見人善",
    second: "即思齊",
    meaning: "看到別人的善行，就要想著向他看齊學習。",
  },
  {
    id: 104,
    category: "信",
    first: "縱去遠",
    second: "以漸躋",
    meaning: "即使現在自己差得很遠，只要努力也能漸漸趕上。",
  },
  {
    id: 105,
    category: "信",
    first: "見人惡",
    second: "即內省",
    meaning: "看到別人的惡行，就要立刻自我反省。",
  },
  {
    id: 106,
    category: "信",
    first: "有則改",
    second: "無加警",
    meaning: "自己若有同樣的缺點就改掉，沒有也要提高警覺。",
  },
  {
    id: 107,
    category: "信",
    first: "唯德學",
    second: "唯才藝",
    meaning: "只有在品德學問，或者是才華技藝方面。",
  },
  {
    id: 108,
    category: "信",
    first: "不如人",
    second: "當自礪",
    meaning: "如果比不上別人，就應當自我勉勵去進步。",
  },
  {
    id: 109,
    category: "信",
    first: "若衣服",
    second: "若飲食",
    meaning: "如果只是在衣服穿著，或者是飲食享受方面。",
  },
  {
    id: 110,
    category: "信",
    first: "不如人",
    second: "勿生戚",
    meaning: "比不上別人，也不需要為此感到悲傷自卑。",
  },
  {
    id: 111,
    category: "信",
    first: "聞過怒",
    second: "聞譽樂",
    meaning: "如果聽到別人指出自己缺點就生氣，聽到稱讚就高興。",
  },
  {
    id: 112,
    category: "信",
    first: "損友來",
    second: "益友卻",
    meaning: "那麼壞朋友就會靠近你，好朋友就會遠離你。",
  },
  {
    id: 113,
    category: "信",
    first: "聞譽恐",
    second: "聞過欣",
    meaning: "聽到稱讚會感到誠惶誠恐，聽到別人指出缺點會虛心歡喜。",
  },
  {
    id: 114,
    category: "信",
    first: "直諒士",
    second: "漸相親",
    meaning: "那麼正直誠信的好朋友，就會漸漸來親近你。",
  },
  {
    id: 115,
    category: "信",
    first: "無心非",
    second: "名為錯",
    meaning: "不是有心犯下的過失，我們稱之為錯誤。",
  },
  {
    id: 116,
    category: "信",
    first: "有心非",
    second: "名為惡",
    meaning: "如果是明知故犯，那就是罪惡了。",
  },
  {
    id: 117,
    category: "信",
    first: "過能改",
    second: "歸於無",
    meaning: "有了過錯只要能勇於改正，過錯就會漸漸消失。",
  },
  {
    id: 118,
    category: "信",
    first: "倘掩飾",
    second: "增一辜",
    meaning: "如果刻意掩飾過錯，那就是錯上加錯，罪加一等了。",
  },

  // --- 汎愛眾 (30) ---
  {
    id: 119,
    category: "汎愛眾",
    first: "凡是人",
    second: "皆須愛",
    meaning: "只要是人，我們都要懷抱著愛心去互相對待。",
  },
  {
    id: 120,
    category: "汎愛眾",
    first: "天同覆",
    second: "地同載",
    meaning: "因為我們都生活在同一片天空下，同一塊土地上。",
  },
  {
    id: 121,
    category: "汎愛眾",
    first: "行高者",
    second: "名自高",
    meaning: "品行高尚的人，名望自然就會高。",
  },
  {
    id: 122,
    category: "汎愛眾",
    first: "人所重",
    second: "非貌高",
    meaning: "人們所敬重的，是他的品德，而不是出眾的外貌。",
  },
  {
    id: 123,
    category: "汎愛眾",
    first: "才大者",
    second: "望自大",
    meaning: "才能出眾的人，聲望自然就會大。",
  },
  {
    id: 124,
    category: "汎愛眾",
    first: "人所服",
    second: "非言大",
    meaning: "人們所信服的，是他的真才實學，不是誇大的言辭。",
  },
  {
    id: 125,
    category: "汎愛眾",
    first: "己有能",
    second: "勿自私",
    meaning: "自己有能力，不要自私自利，要樂於幫助別人。",
  },
  {
    id: 126,
    category: "汎愛眾",
    first: "人所能",
    second: "勿輕訾",
    meaning: "別人有能力，也不要隨便貶低或嫉妒對方。",
  },
  {
    id: 127,
    category: "汎愛眾",
    first: "勿諂富",
    second: "勿驕貧",
    meaning: "不要去討好富有的人，也不要在窮人面前驕傲。",
  },
  {
    id: 128,
    category: "汎愛眾",
    first: "勿厭故",
    second: "勿喜新",
    meaning: "不要厭棄老朋友，也不要只喜歡結交新朋友。",
  },
  {
    id: 129,
    category: "汎愛眾",
    first: "人不閒",
    second: "勿事攪",
    meaning: "當別人正忙碌沒空時，不要拿事情去打擾他。",
  },
  {
    id: 130,
    category: "汎愛眾",
    first: "人不安",
    second: "勿話擾",
    meaning: "當別人身心不安寧時，不要用閒言閒語去擾亂他。",
  },
  {
    id: 131,
    category: "汎愛眾",
    first: "人有短",
    second: "切莫揭",
    meaning: "別人有缺點，千萬不要去揭穿張揚。",
  },
  {
    id: 132,
    category: "汎愛眾",
    first: "人有私",
    second: "切莫說",
    meaning: "別人有隱私或秘密，千萬不要到處亂說。",
  },
  {
    id: 133,
    category: "汎愛眾",
    first: "道人善",
    second: "即是善",
    meaning: "稱讚別人的優點，這本身就是一件好事。",
  },
  {
    id: 134,
    category: "汎愛眾",
    first: "人知之",
    second: "愈思勉",
    meaning: "別人知道了你的稱讚，就會更加勉勵自己向善。",
  },
  {
    id: 135,
    category: "汎愛眾",
    first: "揚人惡",
    second: "即是惡",
    meaning: "宣揚別人的過錯，這本身就是一件壞事。",
  },
  {
    id: 136,
    category: "汎愛眾",
    first: "疾之甚",
    second: "禍且作",
    meaning: "如果批評得太過分，災禍就會隨之而來。",
  },
  {
    id: 137,
    category: "汎愛眾",
    first: "善相勸",
    second: "德皆建",
    meaning: "互相勸導做善事，彼此的品德都能建立起來。",
  },
  {
    id: 138,
    category: "汎愛眾",
    first: "過不規",
    second: "道兩虧",
    meaning: "有了過錯如果不互相規勸，雙方的品德都會有虧損。",
  },
  {
    id: 139,
    category: "汎愛眾",
    first: "凡取與",
    second: "貴分曉",
    meaning: "凡是拿取或給予，最重要的是要界線分明、清清楚楚。",
  },
  {
    id: 140,
    category: "汎愛眾",
    first: "與宜多",
    second: "取宜少",
    meaning: "給予別人的應該多一些，自己拿取的應該少一些。",
  },
  {
    id: 141,
    category: "汎愛眾",
    first: "將加人",
    second: "先問己",
    meaning: "想要將事情加在別人身上，要先問問自己願不願意。",
  },
  {
    id: 142,
    category: "汎愛眾",
    first: "己不欲",
    second: "即速已",
    meaning: "如果連自己都不願意，就要立刻停止，別強加於人。",
  },
  {
    id: 143,
    category: "汎愛眾",
    first: "恩欲報",
    second: "怨欲忘",
    meaning: "受人恩惠要想著報答，跟人結怨要想辦法忘掉。",
  },
  {
    id: 144,
    category: "汎愛眾",
    first: "報怨短",
    second: "報恩長",
    meaning: "報復怨恨的時間要短，報答恩情的時間要長久。",
  },
  {
    id: 145,
    category: "汎愛眾",
    first: "待婢僕",
    second: "身貴端",
    meaning: "對待家中的僕人或員工，自己的行為必須端正莊重。",
  },
  {
    id: 146,
    category: "汎愛眾",
    first: "雖貴端",
    second: "慈而寬",
    meaning: "雖然行為要端正嚴肅，但心地要仁慈寬厚。",
  },
  {
    id: 147,
    category: "汎愛眾",
    first: "勢服人",
    second: "心不然",
    meaning: "如果只用權勢來壓服別人，別人口服心卻不服。",
  },
  {
    id: 148,
    category: "汎愛眾",
    first: "理服人",
    second: "方無言",
    meaning: "只有用道理來讓人信服，別人才會無話可說。",
  },

  // --- 親仁 (8) ---
  {
    id: 149,
    category: "親仁",
    first: "同是人",
    second: "類不齊",
    meaning: "雖然大家都是人，但品行和道德高低卻很不一樣。",
  },
  {
    id: 150,
    category: "親仁",
    first: "流俗眾",
    second: "仁者希",
    meaning: "跟著世俗隨波逐流的人很多，真正有仁德的人卻很少。",
  },
  {
    id: 151,
    category: "親仁",
    first: "果仁者",
    second: "人多畏",
    meaning: "真正有仁德的人，大家多半會對他產生敬畏之心。",
  },
  {
    id: 152,
    category: "親仁",
    first: "言不諱",
    second: "色不媚",
    meaning: "因為他講話直言不諱不隱瞞，臉上也不會有巴結討好的神情。",
  },
  {
    id: 153,
    category: "親仁",
    first: "能親仁",
    second: "無限好",
    meaning: "如果能親近有仁德的人，好處是無窮無盡的。",
  },
  {
    id: 154,
    category: "親仁",
    first: "德日進",
    second: "過日少",
    meaning: "品德會一天比一天進步，過錯會一天比一天減少。",
  },
  {
    id: 155,
    category: "親仁",
    first: "不親仁",
    second: "無限害",
    meaning: "如果不去親近仁德的人，害處是無窮無盡的。",
  },
  {
    id: 156,
    category: "親仁",
    first: "小人進",
    second: "百事壞",
    meaning: "壞朋友就會趁機接近你，各種事情都會被敗壞。",
  },

  // --- 餘力學文 (24) ---
  {
    id: 157,
    category: "餘力學文",
    first: "不力行",
    second: "但學文",
    meaning: "如果不去努力實踐品德，只是死讀書。",
  },
  {
    id: 158,
    category: "餘力學文",
    first: "長浮華",
    second: "成何人",
    meaning: "只會增長浮誇不實的習氣，會變成什麼樣的人呢？",
  },
  {
    id: 159,
    category: "餘力學文",
    first: "但力行",
    second: "不學文",
    meaning: "如果只是一味死做，不去學習文化知識。",
  },
  {
    id: 160,
    category: "餘力學文",
    first: "任己見",
    second: "昧理真",
    meaning: "就會固執自己的偏見，蒙蔽了真理。",
  },
  {
    id: 161,
    category: "餘力學文",
    first: "讀書法",
    second: "有三到",
    meaning: "讀書的方法，有三個方面要確實做到。",
  },
  {
    id: 162,
    category: "餘力學文",
    first: "心眼口",
    second: "信皆要",
    meaning: "心要專一、眼要看仔細、口要讀出聲，這三者都非常重要。",
  },
  {
    id: 163,
    category: "餘力學文",
    first: "方讀此",
    second: "勿慕彼",
    meaning: "正在讀這本書的時候，不要又想著去讀那本書。",
  },
  {
    id: 164,
    category: "餘力學文",
    first: "此未終",
    second: "彼勿起",
    meaning: "這本書還沒有讀完，就不要隨便開始讀另一本。",
  },
  {
    id: 165,
    category: "餘力學文",
    first: "寬為限",
    second: "緊用功",
    meaning: "讀書計畫的時間可以定得寬裕些，但執行時要抓緊時間用功。",
  },
  {
    id: 166,
    category: "餘力學文",
    first: "工夫到",
    second: "滯塞通",
    meaning: "只要功夫下得深，原本不懂的阻礙自然就會貫通了。",
  },
  {
    id: 167,
    category: "餘力學文",
    first: "心有疑",
    second: "隨札記",
    meaning: "心裡有疑問時，要隨時用筆記記下來。",
  },
  {
    id: 168,
    category: "餘力學文",
    first: "就人問",
    second: "求確義",
    meaning: "向懂的人請教，以求得正確的意義。",
  },
  {
    id: 169,
    category: "餘力學文",
    first: "房室清",
    second: "牆壁淨",
    meaning: "書房要整理得清淨，牆壁也要保持乾淨。",
  },
  {
    id: 170,
    category: "餘力學文",
    first: "几案潔",
    second: "筆硯正",
    meaning: "書桌要保持清潔，筆和硯台也要擺放端正。",
  },
  {
    id: 171,
    category: "餘力學文",
    first: "墨磨偏",
    second: "心不端",
    meaning: "如果墨條磨歪了，代表心思不夠端正集中。",
  },
  {
    id: 172,
    category: "餘力學文",
    first: "字不敬",
    second: "心先病",
    meaning: "寫出來的字跡潦草敷衍，代表心態已經先出了毛病。",
  },
  {
    id: 173,
    category: "餘力學文",
    first: "列典籍",
    second: "有定處",
    meaning: "陳列經典書籍時，要有固定的位置。",
  },
  {
    id: 174,
    category: "餘力學文",
    first: "讀看畢",
    second: "還原處",
    meaning: "讀完看畢之後，一定要放回原來的地方。",
  },
  {
    id: 175,
    category: "餘力學文",
    first: "雖有急",
    second: "卷束齊",
    meaning: "雖然有急事，也要把書本收齊放好再離開。",
  },
  {
    id: 176,
    category: "餘力學文",
    first: "有缺壞",
    second: "就補之",
    meaning: "發現書本有缺損壞掉的地方，就要立刻修補好。",
  },
  {
    id: 177,
    category: "餘力學文",
    first: "非聖書",
    second: "屏勿視",
    meaning: "不是聖賢所寫的好書，要屏棄不看。",
  },
  {
    id: 178,
    category: "餘力學文",
    first: "蔽聰明",
    second: "壞心志",
    meaning: "因為那些書會蒙蔽我們的聰明才智，敗壞我們的心志。",
  },
  {
    id: 179,
    category: "餘力學文",
    first: "勿自暴",
    second: "勿自棄",
    meaning: "不要糟蹋自己，也不要放棄自己。",
  },
  {
    id: 180,
    category: "餘力學文",
    first: "聖與賢",
    second: "可馴致",
    meaning: "只要肯努力學習，聖賢的境界也是可以慢慢達到的。",
  },
];

const categories = [
  "全部",
  "總敘",
  "入則孝",
  "出則弟",
  "謹",
  "信",
  "汎愛眾",
  "親仁",
  "餘力學文",
];
const selectableCategories = [
  "入則孝",
  "出則弟",
  "謹",
  "信",
  "汎愛眾",
  "親仁",
  "餘力學文",
];

// --- 實用工具函數 ---
const shuffleArray = (array) => {
  const newArr = [...array];
  for (let i = newArr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [newArr[i], newArr[j]] = [newArr[j], newArr[i]];
  }
  return newArr;
};

const generateOptions = (correctAnswer, type, currentId) => {
  let pool = [];
  if (type === "sentence") {
    pool = diZiGuiData
      .filter((item) => item.id !== currentId)
      .map((item) => item.second);
  } else if (type === "meaning") {
    pool = diZiGuiData
      .filter((item) => item.id !== currentId)
      .map((item) => `${item.first}，${item.second}`);
  }
  const shuffledPool = shuffleArray(pool);
  const options = [correctAnswer, ...shuffledPool.slice(0, 3)];
  return shuffleArray(options);
};

export default function App() {
  const [currentScreen, setCurrentScreen] = useState("menu");
  const [questions, setQuestions] = useState([]);
  const [currentQIndex, setCurrentQIndex] = useState(0);
  const [score, setScore] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [isAnswerCorrect, setIsAnswerCorrect] = useState(null);
  const [gameModeTitle, setGameModeTitle] = useState("");
  const [activeFilter, setActiveFilter] = useState("全部");
  const [isWaitingForNext, setIsWaitingForNext] = useState(false);

  const [pendingGameMode, setPendingGameMode] = useState(null);
  // 預設只勾選「全篇章」
  const [selectedChapters, setSelectedChapters] = useState(["全篇章"]);

  const scrollContainerRef = useRef(null);
  const nextButtonRef = useRef(null);

  // --- 語音朗讀系統 ---
  const speak = (text) => {
    if ("speechSynthesis" in window) {
      window.speechSynthesis.cancel();
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = "zh-TW";
      utterance.rate = 0.9;
      utterance.pitch = 1;
      window.speechSynthesis.speak(utterance);
    } else {
      console.warn("您的瀏覽器不支援語音合成功能");
    }
  };

  // 新增：連續朗讀整頁的函式
  const playAll = (data) => {
    if ("speechSynthesis" in window) {
      window.speechSynthesis.cancel(); // 先停止目前正在播放的語音
      // 將該頁的所有句子依序加入播放佇列
      data.forEach((item) => {
        const utterance = new SpeechSynthesisUtterance(
          `${item.first}，${item.second}。意思就是：${item.meaning}`
        );
        utterance.lang = "zh-TW";
        utterance.rate = 0.9;
        utterance.pitch = 1;
        window.speechSynthesis.speak(utterance);
      });
    }
  };

  // 修改：加上 activeFilter，切換篇章時也會自動停止語音
  useEffect(() => {
    return () => {
      if ("speechSynthesis" in window) {
        window.speechSynthesis.cancel();
      }
    };
  }, [currentScreen, currentQIndex, activeFilter]);

  const openChapterSelection = (mode) => {
    setPendingGameMode(mode);
    setCurrentScreen("select_chapters");
  };

  // 切換章節勾選狀態邏輯
  const toggleChapter = (cat) => {
    if (cat === "全篇章") {
      // 如果點擊了「全篇章」，就只選全篇章，清除其他勾選
      setSelectedChapters(["全篇章"]);
    } else {
      // 如果點擊了特定篇章，先確保「全篇章」的勾選被取消
      let newSelection = selectedChapters.filter((c) => c !== "全篇章");

      if (newSelection.includes(cat)) {
        // 如果已經勾選，就取消勾選
        newSelection = newSelection.filter((c) => c !== cat);
      } else {
        // 如果沒勾選，就加入勾選
        newSelection.push(cat);
      }
      setSelectedChapters(newSelection);
    }
  };

  // 初始化遊戲並開始測驗
  const startQuiz = () => {
    let newQuestions = [];
    let filteredData = [];

    // 判斷是否為「全篇章」，是的話涵蓋所有資料（包含總敘），否則依照勾選的篇章篩選
    if (selectedChapters.includes("全篇章")) {
      filteredData = diZiGuiData;
    } else {
      filteredData = diZiGuiData.filter((item) =>
        selectedChapters.includes(item.category)
      );
    }

    const shuffledData = shuffleArray(filteredData).slice(0, 5);

    if (pendingGameMode === "sentence") {
      setGameModeTitle("經典接龍");
      newQuestions = shuffledData.map((item) => ({
        questionText: `${item.first}，_____`,
        correctAnswer: item.second,
        options: generateOptions(item.second, "sentence", item.id),
        meaning: item.meaning,
        category: item.category,
        fullText: `${item.first}，${item.second}`,
      }));
      setCurrentScreen("play_sentence");
    } else if (pendingGameMode === "meaning") {
      setGameModeTitle("白話解碼");
      newQuestions = shuffledData.map((item) => ({
        questionText: item.meaning,
        correctAnswer: `${item.first}，${item.second}`,
        options: generateOptions(
          `${item.first}，${item.second}`,
          "meaning",
          item.id
        ),
        meaning: item.meaning,
        category: item.category,
        fullText: `${item.first}，${item.second}`,
      }));
      setCurrentScreen("play_meaning");
    }

    setQuestions(newQuestions);
    setCurrentQIndex(0);
    setScore(0);
    setSelectedAnswer(null);
    setIsAnswerCorrect(null);
    setIsWaitingForNext(false);
  };

  const handleAnswerClick = (option) => {
    if (selectedAnswer !== null) return;

    const currentQ = questions[currentQIndex];
    const correct = option === currentQ.correctAnswer;

    setSelectedAnswer(option);
    setIsAnswerCorrect(correct);
    if (correct) {
      setScore((prev) => prev + 20);
    }

    setIsWaitingForNext(true);

    setTimeout(() => {
      if (nextButtonRef.current) {
        nextButtonRef.current.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }
    }, 100);
  };

  const handleNextQuestion = () => {
    if (currentQIndex < questions.length - 1) {
      setCurrentQIndex((prev) => prev + 1);
      setSelectedAnswer(null);
      setIsAnswerCorrect(null);
      setIsWaitingForNext(false);
      if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollTop = 0;
      }
    } else {
      setCurrentScreen("result");
    }
  };

  const getCategoryTheme = (category) => {
    switch (category) {
      case "總敘":
        return {
          bg: "bg-slate-100",
          text: "text-slate-700",
          border: "border-slate-300",
        };
      case "入則孝":
        return {
          bg: "bg-amber-100",
          text: "text-amber-700",
          border: "border-amber-300",
        };
      case "出則弟":
        return {
          bg: "bg-orange-100",
          text: "text-orange-700",
          border: "border-orange-300",
        };
      case "謹":
        return {
          bg: "bg-emerald-100",
          text: "text-emerald-700",
          border: "border-emerald-300",
        };
      case "信":
        return {
          bg: "bg-teal-100",
          text: "text-teal-700",
          border: "border-teal-300",
        };
      case "汎愛眾":
        return {
          bg: "bg-rose-100",
          text: "text-rose-700",
          border: "border-rose-300",
        };
      case "親仁":
        return {
          bg: "bg-purple-100",
          text: "text-purple-700",
          border: "border-purple-300",
        };
      case "餘力學文":
        return {
          bg: "bg-indigo-100",
          text: "text-indigo-700",
          border: "border-indigo-300",
        };
      default:
        return {
          bg: "bg-gray-100",
          text: "text-gray-700",
          border: "border-gray-300",
        };
    }
  };

  // --- 畫面組件 ---
  const renderMenu = () => (
    <div className="flex flex-col items-center justify-center h-full w-full px-2">
      <div className="flex flex-col items-center justify-center w-full max-w-sm space-y-4 sm:space-y-5">
        <div className="bg-amber-100 p-4 sm:p-5 rounded-full shadow-inner flex items-center justify-center relative">
          <Sparkles className="absolute -top-2 -right-2 text-amber-500 w-6 h-6 animate-pulse" />
          <ScrollText className="text-amber-800 w-12 h-12 sm:w-14 sm:h-14" />
        </div>

        <div className="flex flex-col items-center space-y-2">
          <h1 className="text-3xl sm:text-4xl font-bold text-amber-900 tracking-widest text-center">
            弟子規
          </h1>
          <div className="bg-amber-800 text-white px-4 py-1 rounded-full text-sm font-bold tracking-widest shadow-sm">
            完整典藏版
          </div>
        </div>

        <p className="text-amber-700 text-sm sm:text-base text-center leading-relaxed px-2">
          收錄完整八大篇章，支援智慧語音朗讀
          <br />
          傳承經典智慧，培養良好品德
        </p>

        <div className="w-full space-y-3 pt-2">
          <button
            onClick={() => {
              setActiveFilter("全部");
              setCurrentScreen("learn");
            }}
            className="w-full flex items-center justify-between p-3 sm:p-4 bg-white rounded-xl shadow-md border-2 border-amber-200 hover:bg-amber-50 hover:border-amber-400 transition-all text-amber-900 font-semibold text-base sm:text-lg"
          >
            <span className="flex items-center">
              <BookOpen className="mr-3 w-5 h-5 sm:w-6 sm:h-6" /> 溫故知新
              (聽讀學習)
            </span>
            <ArrowRight size={20} className="text-amber-500" />
          </button>

          <button
            onClick={() => openChapterSelection("sentence")}
            className="w-full flex items-center justify-between p-3 sm:p-4 bg-emerald-600 rounded-xl shadow-md border-2 border-emerald-700 hover:bg-emerald-500 transition-all text-white font-semibold text-base sm:text-lg"
          >
            <span className="flex items-center">
              <Play className="mr-3 w-5 h-5 sm:w-6 sm:h-6" /> 經典接龍
              (隨機抽考)
            </span>
            <ArrowRight size={20} className="text-emerald-300" />
          </button>

          <button
            onClick={() => openChapterSelection("meaning")}
            className="w-full flex items-center justify-between p-3 sm:p-4 bg-sky-600 rounded-xl shadow-md border-2 border-sky-700 hover:bg-sky-500 transition-all text-white font-semibold text-base sm:text-lg"
          >
            <span className="flex items-center">
              <Play className="mr-3 w-5 h-5 sm:w-6 sm:h-6" /> 白話解碼
              (字義配對)
            </span>
            <ArrowRight size={20} className="text-sky-300" />
          </button>
        </div>
      </div>
    </div>
  );

  const renderChapterSelection = () => (
    <div className="flex flex-col h-full w-full max-w-md mx-auto px-2">
      <div className="flex items-center justify-between mb-4 shrink-0 pt-2">
        <h2 className="text-xl sm:text-2xl font-bold text-amber-900 flex items-center">
          <CheckSquare className="mr-2" /> 選擇測驗範圍
        </h2>
        <button
          onClick={() => setCurrentScreen("menu")}
          className="p-2 bg-amber-200 text-amber-800 rounded-full hover:bg-amber-300 transition-colors"
        >
          <Home size={20} className="sm:w-6 sm:h-6" />
        </button>
      </div>

      <div className="text-sm text-amber-700 mb-4 px-1 shrink-0 bg-amber-50 p-3 rounded-xl border border-amber-200 leading-relaxed">
        📌
        預設為全篇章測驗。您也可以單獨點選底下特定篇章進行加強特訓。系統將隨機抽出
        5 題測驗。
      </div>

      <div className="flex-1 overflow-y-auto custom-scrollbar px-1 pb-4">
        <div className="grid grid-cols-2 gap-3 sm:gap-4">
          {/* 全篇章按鈕：現在與其他選項同寬，排在第一列 */}
          <button
            onClick={() => toggleChapter("全篇章")}
            className={`p-3 sm:p-4 rounded-xl border-2 font-bold text-lg text-center transition-all flex items-center justify-center min-h-[60px] ${
              selectedChapters.includes("全篇章")
                ? "bg-amber-100 text-amber-800 border-amber-400 shadow-sm ring-2 ring-offset-2 ring-amber-400 opacity-100"
                : "bg-white text-gray-400 border-gray-200 opacity-60 hover:opacity-100 hover:bg-amber-50"
            }`}
          >
            <Sparkles
              className={`mr-2 w-5 h-5 ${
                selectedChapters.includes("全篇章")
                  ? "text-amber-500"
                  : "text-gray-400"
              }`}
            />{" "}
            全篇章
          </button>

          {/* 其他篇章按鈕 */}
          {selectableCategories.map((cat) => {
            const isSelected = selectedChapters.includes(cat);
            const theme = getCategoryTheme(cat);
            return (
              <button
                key={cat}
                onClick={() => toggleChapter(cat)}
                className={`p-3 sm:p-4 rounded-xl border-2 font-bold text-center transition-all flex items-center justify-center min-h-[60px] ${
                  isSelected
                    ? `${theme.bg} ${theme.text} ${theme.border} shadow-sm ring-2 ring-offset-2 ring-amber-400 opacity-100`
                    : "bg-white text-gray-400 border-gray-200 opacity-60 hover:opacity-100 hover:bg-gray-50"
                }`}
              >
                {cat}
              </button>
            );
          })}
        </div>
      </div>

      <button
        onClick={startQuiz}
        disabled={selectedChapters.length === 0}
        className={`mt-4 mb-2 w-full py-4 rounded-xl font-bold text-lg shadow-md flex items-center justify-center transition-colors shrink-0 ${
          selectedChapters.length === 0
            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
            : "bg-emerald-600 hover:bg-emerald-500 text-white"
        }`}
      >
        開始測驗 <Play className="ml-2 w-5 h-5" />
      </button>
    </div>
  );

  const renderLearn = () => {
    const filteredData =
      activeFilter === "全部"
        ? diZiGuiData
        : diZiGuiData.filter((item) => item.category === activeFilter);

    return (
      <div className="flex flex-col h-full w-full max-w-md mx-auto">
        <div className="flex items-center justify-between mb-4 shrink-0 pt-2">
          <h2 className="text-xl sm:text-2xl font-bold text-amber-900 flex items-center">
            <BookOpen className="mr-2" /> 溫故知新
          </h2>
          <button
            onClick={() => setCurrentScreen("menu")}
            className="p-2 bg-amber-200 text-amber-800 rounded-full hover:bg-amber-300 transition-colors"
          >
            <Home size={20} className="sm:w-6 sm:h-6" />
          </button>
        </div>

        {/* 分類標籤滑動區 */}
        <div className="flex overflow-x-auto custom-scrollbar pb-3 mb-2 space-x-2 shrink-0 px-1">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveFilter(cat)}
              className={`whitespace-nowrap px-3 py-1.5 rounded-full text-sm font-bold border-2 transition-colors ${
                activeFilter === cat
                  ? "bg-amber-600 text-white border-amber-700 shadow-sm"
                  : "bg-white text-amber-700 border-amber-200 hover:bg-amber-50"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="flex-1 overflow-y-auto space-y-3 sm:space-y-4 pr-2 custom-scrollbar pb-4">
          <div className="flex items-center justify-between bg-amber-100 rounded-full px-3 py-1.5 mb-3 shadow-sm shrink-0">
            <div className="text-xs text-amber-700 font-bold tracking-widest pl-1">
              {activeFilter === "全部"
                ? "收錄全篇 180 組"
                : `本單元共 ${filteredData.length} 組`}
            </div>
            <div className="flex space-x-1 sm:space-x-2">
              <button
                onClick={() => {
                  if ("speechSynthesis" in window)
                    window.speechSynthesis.cancel();
                }}
                className="flex items-center text-xs text-amber-800 font-bold bg-amber-200 hover:bg-amber-300 px-2 sm:px-3 py-1 rounded-full transition-all shadow-sm"
                title="停止朗讀"
              >
                停止
              </button>
              <button
                onClick={() => playAll(filteredData)}
                className="flex items-center text-xs text-white font-bold bg-amber-500 hover:bg-amber-400 px-2 sm:px-3 py-1 rounded-full transition-all shadow-sm"
                title="連續朗讀本頁內容"
              >
                <Volume2 size={14} className="mr-1" />
                全部朗讀
              </button>
            </div>
          </div>
          {filteredData.map((item) => {
            const theme = getCategoryTheme(item.category);
            return (
              <div
                key={item.id}
                className="bg-white p-4 sm:p-5 rounded-xl shadow-sm border border-amber-100 relative overflow-hidden group hover:shadow-md transition-shadow"
              >
                <div
                  className={`absolute top-0 left-0 w-1.5 h-full ${theme.bg.replace(
                    "100",
                    "400"
                  )}`}
                ></div>
                <div className="flex justify-between items-start mb-2 ml-1">
                  <div>
                    <span
                      className={`text-xs px-2 py-1 rounded font-bold border ${theme.bg} ${theme.text} ${theme.border} inline-block mb-2`}
                    >
                      {item.category}
                    </span>
                    <h3 className="text-lg sm:text-xl font-bold text-gray-800 tracking-widest">
                      {item.first}，{item.second}
                    </h3>
                  </div>
                  <button
                    onClick={() =>
                      speak(
                        `${item.first}，${item.second}。意思就是：${item.meaning}`
                      )
                    }
                    className="p-2 bg-blue-50 text-blue-600 rounded-full hover:bg-blue-100 hover:scale-110 transition-all shadow-sm shrink-0 ml-2"
                    title="朗讀此句與解釋"
                  >
                    <Volume2 size={20} />
                  </button>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed ml-1 pt-1 border-t border-gray-100">
                  {item.meaning}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const renderGame = () => {
    const currentQ = questions[currentQIndex];
    if (!currentQ) return null;
    const theme = getCategoryTheme(currentQ.category);

    return (
      <div className="flex flex-col w-full max-w-md mx-auto h-full">
        <div className="flex items-center justify-between mb-4 sm:mb-6 shrink-0 pt-2">
          <button
            onClick={() => setCurrentScreen("menu")}
            className="p-2 bg-amber-200 text-amber-800 rounded-full hover:bg-amber-300 transition-colors"
          >
            <Home size={20} className="sm:w-6 sm:h-6" />
          </button>
          <div className="text-sm sm:text-base font-bold text-amber-800 bg-amber-100 px-3 py-1 sm:px-4 rounded-full">
            {gameModeTitle} - 第 {currentQIndex + 1} / {questions.length} 題
          </div>
          <div className="text-base sm:text-lg font-bold text-emerald-600">
            {score} 分
          </div>
        </div>

        <div
          ref={scrollContainerRef}
          className="flex-1 overflow-y-auto custom-scrollbar pr-1 pb-24 flex flex-col relative"
        >
          <div
            className={`bg-white p-6 sm:p-8 rounded-2xl shadow-md border-2 border-amber-100 mb-4 sm:mb-6 flex flex-col items-center text-center min-h-[140px] sm:min-h-[160px] justify-center relative shrink-0`}
          >
            <div className="absolute top-3 w-full px-3 flex justify-between items-center box-border left-0">
              <button
                onClick={() =>
                  speak(
                    currentScreen === "play_sentence"
                      ? currentQ.questionText.replace("_____", "什麼呢？")
                      : currentQ.questionText
                  )
                }
                className="p-1.5 bg-blue-50 text-blue-600 rounded-full hover:bg-blue-100 hover:scale-110 transition-all shadow-sm"
                title="朗讀題目"
              >
                <Volume2 size={16} />
              </button>
              <span
                className={`text-xs font-bold px-2 py-1 rounded border ${theme.bg} ${theme.text} ${theme.border}`}
              >
                {currentQ.category}
              </span>
            </div>

            <h2
              className={`font-bold text-gray-800 mt-4 ${
                currentScreen === "play_sentence"
                  ? "text-3xl sm:text-4xl tracking-widest"
                  : "text-lg sm:text-xl leading-relaxed"
              }`}
            >
              {currentQ.questionText}
            </h2>

            {selectedAnswer && (
              <div className="absolute inset-0 flex items-center justify-center bg-white/95 rounded-2xl animate-fade-in z-10">
                {isAnswerCorrect ? (
                  <div className="flex flex-col items-center animate-bounce">
                    <CheckCircle2
                      size={64}
                      className="sm:w-20 sm:h-20 text-emerald-500 mb-2"
                    />
                    <span className="text-emerald-600 font-bold text-lg sm:text-xl">
                      答對了！
                    </span>
                  </div>
                ) : (
                  <div className="flex flex-col items-center animate-shake">
                    <XCircle
                      size={64}
                      className="sm:w-20 sm:h-20 text-rose-500 mb-2"
                    />
                    <span className="text-rose-600 font-bold text-lg sm:text-xl">
                      再接再厲！
                    </span>
                  </div>
                )}
              </div>
            )}
          </div>

          <div className="grid grid-cols-1 gap-3 sm:gap-4 w-full shrink-0">
            {currentQ.options.map((option, index) => {
              let btnClass =
                "bg-white text-gray-800 border-2 border-amber-200 hover:bg-amber-50 hover:border-amber-400";
              if (selectedAnswer !== null) {
                if (option === currentQ.correctAnswer) {
                  btnClass =
                    "bg-emerald-100 text-emerald-800 border-2 border-emerald-500 ring-2 ring-emerald-300";
                } else if (option === selectedAnswer && !isAnswerCorrect) {
                  btnClass =
                    "bg-rose-100 text-rose-800 border-2 border-rose-500 opacity-70";
                } else {
                  btnClass =
                    "bg-gray-50 text-gray-400 border-2 border-gray-200 opacity-50";
                }
              }

              return (
                <button
                  key={index}
                  onClick={() => handleAnswerClick(option)}
                  disabled={selectedAnswer !== null}
                  className={`p-3 sm:p-4 rounded-xl text-base sm:text-lg font-semibold transition-all shadow-sm min-h-[56px] ${btnClass} ${
                    currentScreen === "play_meaning" ? "tracking-widest" : ""
                  }`}
                >
                  {option}
                </button>
              );
            })}
          </div>

          {isWaitingForNext && (
            <div className="mt-4 sm:mt-6 animate-fade-in shrink-0 flex flex-col space-y-4">
              <div className="p-4 bg-amber-50 border border-amber-200 rounded-xl text-left shadow-sm relative">
                <button
                  onClick={() =>
                    speak(`${currentQ.fullText}。意思是：${currentQ.meaning}`)
                  }
                  className="absolute top-3 right-3 p-1.5 bg-white text-amber-600 border border-amber-200 rounded-full hover:bg-amber-100 hover:scale-110 transition-all shadow-sm"
                  title="朗讀解答"
                >
                  <Volume2 size={16} />
                </button>
                <span className="font-bold text-amber-900 block mb-2 pr-8">
                  💡 完整解答：
                </span>
                <span className="text-amber-900 font-bold text-lg tracking-widest block mb-2">
                  {currentQ.fullText}
                </span>
                <span className="text-amber-800 text-sm leading-relaxed block border-t border-amber-200/50 pt-2">
                  {currentQ.meaning}
                </span>
              </div>

              <button
                ref={nextButtonRef}
                onClick={handleNextQuestion}
                className="w-full py-4 bg-blue-600 hover:bg-blue-500 text-white rounded-xl font-bold text-lg shadow-md flex items-center justify-center transition-colors"
              >
                {currentQIndex < questions.length - 1 ? "下一題" : "查看成績"}{" "}
                <ChevronRight className="ml-1" />
              </button>
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderResult = () => {
    let message = "";
    if (score === 100) message = "太棒了！你是《弟子規》全能小達人！🌟";
    else if (score >= 60) message = "表現不錯喔！繼續保持！👍";
    else message = "再多複習一下，下次一定會更好！💪";

    // 手動播放成績語音的函式
    const handleSpeakResult = () => {
      let voiceMsg = "";
      if (score === 100) voiceMsg = "太棒了！你是《弟子規》全能小達人！";
      else if (score >= 60) voiceMsg = "表現不錯喔！繼續保持！";
      else voiceMsg = "再多複習一下，下次一定會更好！";
      speak(`測驗結束。你得到了 ${score} 分。${voiceMsg}`);
    };

    return (
      <div className="flex flex-col items-center justify-center h-full w-full max-w-md mx-auto space-y-6 sm:space-y-8 text-center py-4">
        <div className="relative shrink-0">
          <Trophy
            size={80}
            className="sm:w-[100px] sm:h-[100px] text-amber-400 animate-pulse"
          />
          <div className="absolute -top-2 -right-2 sm:-top-4 sm:-right-4 bg-red-500 text-white font-bold text-lg sm:text-xl w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center transform rotate-12 shadow-lg">
            {score}
          </div>
        </div>

        <div className="shrink-0 flex flex-col items-center">
          <div className="flex items-center justify-center mb-2">
            <h2 className="text-2xl sm:text-3xl font-bold text-amber-900">
              測驗結束
            </h2>
            {/* 新增的手動語音按鈕 */}
            <button
              onClick={handleSpeakResult}
              className="ml-3 p-2 bg-blue-50 text-blue-600 rounded-full hover:bg-blue-100 hover:scale-110 transition-all shadow-sm"
              title="朗讀成績"
            >
              <Volume2 size={24} />
            </button>
          </div>
          <p className="text-lg sm:text-xl text-amber-700 px-4">{message}</p>
        </div>

        <div className="bg-white p-4 sm:p-6 rounded-2xl shadow-md w-full border border-amber-100 shrink-0">
          <h3 className="text-base sm:text-lg font-semibold text-gray-600 mb-3 sm:mb-4">
            總結 (綜合測驗)
          </h3>
          <div className="flex justify-between items-center text-lg sm:text-xl mb-2">
            <span className="text-gray-500">總題數</span>
            <span className="font-bold text-gray-800">
              {questions.length} 題
            </span>
          </div>
          <div className="flex justify-between items-center text-lg sm:text-xl">
            <span className="text-gray-500">答對題數</span>
            <span className="font-bold text-emerald-600">{score / 20} 題</span>
          </div>
        </div>

        <button
          onClick={() => setCurrentScreen("menu")}
          className="w-full flex items-center justify-center p-3 sm:p-4 bg-amber-500 rounded-xl shadow-md hover:bg-amber-400 transition-all text-white font-bold text-base sm:text-lg shrink-0 mt-auto sm:mt-0"
        >
          <Home className="mr-2 w-5 h-5 sm:w-6 sm:h-6" /> 回到主選單
        </button>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-stone-100 flex items-center justify-center p-2 sm:p-4 font-sans selection:bg-amber-200">
      {/* 遊戲容器 */}
      <div className="w-full max-w-md bg-stone-50 h-[95dvh] sm:h-[800px] sm:max-h-[95vh] rounded-[1.5rem] sm:rounded-[2rem] shadow-2xl overflow-hidden relative border-[4px] sm:border-[8px] border-white flex flex-col">
        {/* 背景裝飾 */}
        <div className="absolute top-0 left-0 w-full h-full pointer-events-none opacity-20 bg-[url('https://www.transparenttextures.com/patterns/rice-paper.png')]"></div>
        <div className="absolute -top-24 -right-24 w-64 h-64 bg-amber-200 rounded-full mix-blend-multiply filter blur-3xl opacity-50"></div>
        <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-emerald-200 rounded-full mix-blend-multiply filter blur-3xl opacity-40"></div>

        {/* 內容區塊 */}
        <div className="relative z-10 w-full h-full p-4 sm:p-6 flex flex-col min-h-0">
          {currentScreen === "menu" && renderMenu()}
          {currentScreen === "select_chapters" && renderChapterSelection()}
          {currentScreen === "learn" && renderLearn()}
          {(currentScreen === "play_sentence" ||
            currentScreen === "play_meaning") &&
            renderGame()}
          {currentScreen === "result" && renderResult()}
        </div>
      </div>

      <style
        dangerouslySetInnerHTML={{
          __html: `
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fade-in 0.3s ease-out forwards;
        }
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          50% { transform: translateX(5px); }
          75% { transform: translateX(-5px); }
        }
        .animate-shake {
          animation: shake 0.4s ease-in-out;
        }
        /* 隱藏預設捲軸，改用自訂細捲軸 */
        .custom-scrollbar::-webkit-scrollbar {
          height: 4px;
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: transparent; 
          border-radius: 8px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #fcd34d; 
          border-radius: 8px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #fbbf24; 
        }
      `,
        }}
      />
    </div>
  );
}
